var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Main',[_c('div',{staticClass:"error-page error-page__admin"},[_c('div',{staticClass:"countdown-bg countdown-bg__admin"}),_c('div',{staticClass:"error-screen"},[_c('h5',{staticClass:"description-page"},[_vm._v("Welcome to our system"),_c('br'),_vm._v("Good morning and full of energy.")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }